export default "__VITE_ASSET__B6m5w5pK__"